export const timezoneOptions = [
  {
    value: "Pacific/Midway",
    label: "(GMT-11:00) Pacific/Midway",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-11:00) Pacific/Midway
      </span>
    ),
  },
  {
    value: "Pacific/Niue",
    label: "(GMT-11:00) Pacific/Niue",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-11:00) Pacific/Niue
      </span>
    ),
  },
  {
    value: "Pacific/Pago_Pago",
    label: "(GMT-11:00) Pacific/Pago_Pago",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-11:00) Pacific/Pago_Pago
      </span>
    ),
  },
  {
    value: "Pacific/Honolulu",
    label: "(GMT-10:00) Pacific/Honolulu",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-10:00) Pacific/Honolulu
      </span>
    ),
  },
  {
    value: "Pacific/Rarotonga",
    label: "(GMT-10:00) Pacific/Rarotonga",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-10:00) Pacific/Rarotonga
      </span>
    ),
  },
  {
    value: "Pacific/Tahiti",
    label: "(GMT-10:00) Pacific/Tahiti",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-10:00) Pacific/Tahiti
      </span>
    ),
  },
  {
    value: "Pacific/Marquesas",
    label: "(GMT-09:30) Pacific/Marquesas",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-09:30) Pacific/Marquesas
      </span>
    ),
  },
  {
    value: "America/Adak",
    label: "(GMT-09:00) America/Adak",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-09:00) America/Adak
      </span>
    ),
  },
  {
    value: "America/Anchorage",
    label: "(GMT-08:00) America/Anchorage",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-08:00) America/Anchorage
      </span>
    ),
  },
  {
    value: "America/Juneau",
    label: "(GMT-08:00) America/Juneau",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-08:00) America/Juneau
      </span>
    ),
  },
  {
    value: "America/Metlakatla",
    label: "(GMT-08:00) America/Metlakatla",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-08:00) America/Metlakatla
      </span>
    ),
  },
  {
    value: "America/Nome",
    label: "(GMT-08:00) America/Nome",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-08:00) America/Nome
      </span>
    ),
  },
  {
    value: "America/Sitka",
    label: "(GMT-08:00) America/Sitka",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-08:00) America/Sitka
      </span>
    ),
  },
  {
    value: "America/Yakutat",
    label: "(GMT-08:00) America/Yakutat",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-08:00) America/Yakutat
      </span>
    ),
  },
  {
    value: "Pacific/Pitcairn",
    label: "(GMT-08:00) Pacific/Pitcairn",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-08:00) Pacific/Pitcairn
      </span>
    ),
  },
  {
    value: "America/Los_Angeles",
    label: "(GMT-07:00) America/Los_Angeles",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Los_Angeles
      </span>
    ),
  },
  {
    value: "America/Vancouver",
    label: "(GMT-07:00) America/Vancouver",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Vancouver
      </span>
    ),
  },
  {
    value: "America/Tijuana",
    label: "(GMT-07:00) America/Tijuana",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Tijuana
      </span>
    ),
  },
  {
    value: "America/Phoenix",
    label: "(GMT-07:00) America/Phoenix",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Phoenix
      </span>
    ),
  },
  {
    value: "America/Denver",
    label: "(GMT-06:00) America/Denver",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Denver
      </span>
    ),
  },
  {
    value: "America/Chicago",
    label: "(GMT-05:00) America/Chicago",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Chicago
      </span>
    ),
  },
  {
    value: "America/New_York",
    label: "(GMT-04:00) America/New_York",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/New_York
      </span>
    ),
  },
  {
    value: "America/Halifax",
    label: "(GMT-03:00) America/Halifax",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Halifax
      </span>
    ),
  },
  {
    value: "America/St_Johns",
    label: "(GMT-02:30) America/St_Johns",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-02:30) America/St_Johns
      </span>
    ),
  },
  {
    value: "Atlantic/Azores",
    label: "(GMT+00:00) Atlantic/Azores",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Atlantic/Azores
      </span>
    ),
  },
  {
    value: "Europe/London",
    label: "(GMT+01:00) Europe/London",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Europe/London
      </span>
    ),
  },
  {
    value: "Europe/Paris",
    label: "(GMT+02:00) Europe/Paris",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Paris
      </span>
    ),
  },
  {
    value: "Africa/Cairo",
    label: "(GMT+03:00) Africa/Cairo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Africa/Cairo
      </span>
    ),
  },
  {
    value: "Asia/Dubai",
    label: "(GMT+04:00) Asia/Dubai",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Asia/Dubai
      </span>
    ),
  },
  {
    value: "Asia/Karachi",
    label: "(GMT+05:00) Asia/Karachi",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Karachi
      </span>
    ),
  },
  {
    value: "Asia/Kolkata",
    label: "(GMT+05:30) Asia/Kolkata",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:30) Asia/Kolkata
      </span>
    ),
  },
  {
    value: "Asia/Dhaka",
    label: "(GMT+06:00) Asia/Dhaka",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Asia/Dhaka
      </span>
    ),
  },
  {
    value: "Asia/Bangkok",
    label: "(GMT+07:00) Asia/Bangkok",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Bangkok
      </span>
    ),
  },
  {
    value: "Asia/Shanghai",
    label: "(GMT+08:00) Asia/Shanghai",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Shanghai
      </span>
    ),
  },
  {
    value: "Asia/Tokyo",
    label: "(GMT+09:00) Asia/Tokyo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) Asia/Tokyo
      </span>
    ),
  },
  {
    value: "Australia/Sydney",
    label: "(GMT+10:00) Australia/Sydney",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/Sydney
      </span>
    ),
  },
  {
    value: "Pacific/Auckland",
    label: "(GMT+12:00) Pacific/Auckland",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Pacific/Auckland
      </span>
    ),
  },
  // Africa
  {
    value: "Africa/Abidjan",
    label: "(GMT+00:00) Africa/Abidjan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Abidjan
      </span>
    ),
  },
  {
    value: "Africa/Accra",
    label: "(GMT+00:00) Africa/Accra",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Accra
      </span>
    ),
  },
  {
    value: "Africa/Addis_Ababa",
    label: "(GMT+03:00) Africa/Addis_Ababa",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Africa/Addis_Ababa
      </span>
    ),
  },
  {
    value: "Africa/Algiers",
    label: "(GMT+01:00) Africa/Algiers",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Algiers
      </span>
    ),
  },
  {
    value: "Africa/Asmara",
    label: "(GMT+03:00) Africa/Asmara",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Africa/Asmara
      </span>
    ),
  },
  {
    value: "Africa/Asmera",
    label: "(GMT+03:00) Africa/Asmera",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Africa/Asmera
      </span>
    ),
  },
  {
    value: "Africa/Bamako",
    label: "(GMT+00:00) Africa/Bamako",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Bamako
      </span>
    ),
  },
  {
    value: "Africa/Bangui",
    label: "(GMT+01:00) Africa/Bangui",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Bangui
      </span>
    ),
  },
  {
    value: "Africa/Banjul",
    label: "(GMT+00:00) Africa/Banjul",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Banjul
      </span>
    ),
  },
  {
    value: "Africa/Bissau",
    label: "(GMT+00:00) Africa/Bissau",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Bissau
      </span>
    ),
  },
  {
    value: "Africa/Blantyre",
    label: "(GMT+02:00) Africa/Blantyre",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Blantyre
      </span>
    ),
  },
  {
    value: "Africa/Brazzaville",
    label: "(GMT+01:00) Africa/Brazzaville",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Brazzaville
      </span>
    ),
  },
  {
    value: "Africa/Bujumbura",
    label: "(GMT+02:00) Africa/Bujumbura",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Bujumbura
      </span>
    ),
  },
  {
    value: "Africa/Casablanca",
    label: "(GMT+01:00) Africa/Casablanca",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Casablanca
      </span>
    ),
  },
  {
    value: "Africa/Ceuta",
    label: "(GMT+02:00) Africa/Ceuta",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Ceuta
      </span>
    ),
  },
  {
    value: "Africa/Conakry",
    label: "(GMT+00:00) Africa/Conakry",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Conakry
      </span>
    ),
  },
  {
    value: "Africa/Dakar",
    label: "(GMT+00:00) Africa/Dakar",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Dakar
      </span>
    ),
  },
  {
    value: "Africa/Dar_es_Salaam",
    label: "(GMT+03:00) Africa/Dar_es_Salaam",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Africa/Dar_es_Salaam
      </span>
    ),
  },
  {
    value: "Africa/Djibouti",
    label: "(GMT+03:00) Africa/Djibouti",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Africa/Djibouti
      </span>
    ),
  },
  {
    value: "Africa/Douala",
    label: "(GMT+01:00) Africa/Douala",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Douala
      </span>
    ),
  },
  {
    value: "Africa/El_Aaiun",
    label: "(GMT+01:00) Africa/El_Aaiun",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/El_Aaiun
      </span>
    ),
  },
  {
    value: "Africa/Freetown",
    label: "(GMT+00:00) Africa/Freetown",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Freetown
      </span>
    ),
  },
  {
    value: "Africa/Gaborone",
    label: "(GMT+02:00) Africa/Gaborone",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Gaborone
      </span>
    ),
  },
  {
    value: "Africa/Harare",
    label: "(GMT+02:00) Africa/Harare",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Harare
      </span>
    ),
  },
  {
    value: "Africa/Johannesburg",
    label: "(GMT+02:00) Africa/Johannesburg",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Johannesburg
      </span>
    ),
  },
  {
    value: "Africa/Juba",
    label: "(GMT+02:00) Africa/Juba",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Juba
      </span>
    ),
  },
  {
    value: "Africa/Kampala",
    label: "(GMT+03:00) Africa/Kampala",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Africa/Kampala
      </span>
    ),
  },
  {
    value: "Africa/Khartoum",
    label: "(GMT+02:00) Africa/Khartoum",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Khartoum
      </span>
    ),
  },
  {
    value: "Africa/Kigali",
    label: "(GMT+02:00) Africa/Kigali",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Kigali
      </span>
    ),
  },
  {
    value: "Africa/Kinshasa",
    label: "(GMT+01:00) Africa/Kinshasa",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Kinshasa
      </span>
    ),
  },
  {
    value: "Africa/Lagos",
    label: "(GMT+01:00) Africa/Lagos",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Lagos
      </span>
    ),
  },
  {
    value: "Africa/Libreville",
    label: "(GMT+01:00) Africa/Libreville",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Libreville
      </span>
    ),
  },
  {
    value: "Africa/Lome",
    label: "(GMT+00:00) Africa/Lome",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Lome
      </span>
    ),
  },
  {
    value: "Africa/Luanda",
    label: "(GMT+01:00) Africa/Luanda",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Luanda
      </span>
    ),
  },
  {
    value: "Africa/Lubumbashi",
    label: "(GMT+02:00) Africa/Lubumbashi",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Lubumbashi
      </span>
    ),
  },
  {
    value: "Africa/Lusaka",
    label: "(GMT+02:00) Africa/Lusaka",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Lusaka
      </span>
    ),
  },
  {
    value: "Africa/Malabo",
    label: "(GMT+01:00) Africa/Malabo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Malabo
      </span>
    ),
  },
  {
    value: "Africa/Maputo",
    label: "(GMT+02:00) Africa/Maputo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Maputo
      </span>
    ),
  },
  {
    value: "Africa/Maseru",
    label: "(GMT+02:00) Africa/Maseru",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Maseru
      </span>
    ),
  },
  {
    value: "Africa/Mbabane",
    label: "(GMT+02:00) Africa/Mbabane",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Mbabane
      </span>
    ),
  },
  {
    value: "Africa/Mogadishu",
    label: "(GMT+03:00) Africa/Mogadishu",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Africa/Mogadishu
      </span>
    ),
  },
  {
    value: "Africa/Monrovia",
    label: "(GMT+00:00) Africa/Monrovia",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Monrovia
      </span>
    ),
  },
  {
    value: "Africa/Nairobi",
    label: "(GMT+03:00) Africa/Nairobi",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Africa/Nairobi
      </span>
    ),
  },
  {
    value: "Africa/Ndjamena",
    label: "(GMT+01:00) Africa/Ndjamena",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Ndjamena
      </span>
    ),
  },
  {
    value: "Africa/Niamey",
    label: "(GMT+01:00) Africa/Niamey",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Niamey
      </span>
    ),
  },
  {
    value: "Africa/Nouakchott",
    label: "(GMT+00:00) Africa/Nouakchott",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Nouakchott
      </span>
    ),
  },
  {
    value: "Africa/Ouagadougou",
    label: "(GMT+00:00) Africa/Ouagadougou",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Ouagadougou
      </span>
    ),
  },
  {
    value: "Africa/Porto-Novo",
    label: "(GMT+01:00) Africa/Porto-Novo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Porto-Novo
      </span>
    ),
  },
  {
    value: "Africa/Sao_Tome",
    label: "(GMT+00:00) Africa/Sao_Tome",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Sao_Tome
      </span>
    ),
  },
  {
    value: "Africa/Timbuktu",
    label: "(GMT+00:00) Africa/Timbuktu",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Africa/Timbuktu
      </span>
    ),
  },
  {
    value: "Africa/Tripoli",
    label: "(GMT+02:00) Africa/Tripoli",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Tripoli
      </span>
    ),
  },
  {
    value: "Africa/Tunis",
    label: "(GMT+01:00) Africa/Tunis",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Africa/Tunis
      </span>
    ),
  },
  {
    value: "Africa/Windhoek",
    label: "(GMT+02:00) Africa/Windhoek",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Africa/Windhoek
      </span>
    ),
  },
  // America
  {
    value: "America/Anguilla",
    label: "(GMT-04:00) America/Anguilla",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Anguilla
      </span>
    ),
  },
  {
    value: "America/Antigua",
    label: "(GMT-04:00) America/Antigua",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Antigua
      </span>
    ),
  },
  {
    value: "America/Araguaina",
    label: "(GMT-03:00) America/Araguaina",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Araguaina
      </span>
    ),
  },
  {
    value: "America/Argentina/Buenos_Aires",
    label: "(GMT-03:00) America/Argentina/Buenos_Aires",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/Buenos_Aires
      </span>
    ),
  },
  {
    value: "America/Argentina/Catamarca",
    label: "(GMT-03:00) America/Argentina/Catamarca",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/Catamarca
      </span>
    ),
  },
  {
    value: "America/Argentina/Cordoba",
    label: "(GMT-03:00) America/Argentina/Cordoba",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/Cordoba
      </span>
    ),
  },
  {
    value: "America/Argentina/Jujuy",
    label: "(GMT-03:00) America/Argentina/Jujuy",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/Jujuy
      </span>
    ),
  },
  {
    value: "America/Argentina/La_Rioja",
    label: "(GMT-03:00) America/Argentina/La_Rioja",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/La_Rioja
      </span>
    ),
  },
  {
    value: "America/Argentina/Mendoza",
    label: "(GMT-03:00) America/Argentina/Mendoza",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/Mendoza
      </span>
    ),
  },
  {
    value: "America/Argentina/Rio_Gallegos",
    label: "(GMT-03:00) America/Argentina/Rio_Gallegos",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/Rio_Gallegos
      </span>
    ),
  },
  {
    value: "America/Argentina/Salta",
    label: "(GMT-03:00) America/Argentina/Salta",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/Salta
      </span>
    ),
  },
  {
    value: "America/Argentina/San_Juan",
    label: "(GMT-03:00) America/Argentina/San_Juan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/San_Juan
      </span>
    ),
  },
  {
    value: "America/Argentina/San_Luis",
    label: "(GMT-03:00) America/Argentina/San_Luis",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/San_Luis
      </span>
    ),
  },
  {
    value: "America/Argentina/Tucuman",
    label: "(GMT-03:00) America/Argentina/Tucuman",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/Tucuman
      </span>
    ),
  },
  {
    value: "America/Argentina/Ushuaia",
    label: "(GMT-03:00) America/Argentina/Ushuaia",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Argentina/Ushuaia
      </span>
    ),
  },
  {
    value: "America/Aruba",
    label: "(GMT-04:00) America/Aruba",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Aruba
      </span>
    ),
  },
  {
    value: "America/Asuncion",
    label: "(GMT-03:00) America/Asuncion",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Asuncion
      </span>
    ),
  },
  {
    value: "America/Atikokan",
    label: "(GMT-05:00) America/Atikokan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Atikokan
      </span>
    ),
  },
  {
    value: "America/Atka",
    label: "(GMT-09:00) America/Atka",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-09:00) America/Atka
      </span>
    ),
  },
  {
    value: "America/Bahia",
    label: "(GMT-03:00) America/Bahia",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Bahia
      </span>
    ),
  },
  {
    value: "America/Bahia_Banderas",
    label: "(GMT-06:00) America/Bahia_Banderas",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Bahia_Banderas
      </span>
    ),
  },
  {
    value: "America/Barbados",
    label: "(GMT-04:00) America/Barbados",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Barbados
      </span>
    ),
  },
  {
    value: "America/Belem",
    label: "(GMT-03:00) America/Belem",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Belem
      </span>
    ),
  },
  {
    value: "America/Belize",
    label: "(GMT-06:00) America/Belize",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Belize
      </span>
    ),
  },
  {
    value: "America/Blanc-Sablon",
    label: "(GMT-04:00) America/Blanc-Sablon",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Blanc-Sablon
      </span>
    ),
  },
  {
    value: "America/Boa_Vista",
    label: "(GMT-04:00) America/Boa_Vista",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Boa_Vista
      </span>
    ),
  },
  {
    value: "America/Bogota",
    label: "(GMT-05:00) America/Bogota",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Bogota
      </span>
    ),
  },
  {
    value: "America/Boise",
    label: "(GMT-06:00) America/Boise",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Boise
      </span>
    ),
  },
  {
    value: "America/Buenos_Aires",
    label: "(GMT-03:00) America/Buenos_Aires",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Buenos_Aires
      </span>
    ),
  },
  {
    value: "America/Cambridge_Bay",
    label: "(GMT-06:00) America/Cambridge_Bay",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Cambridge_Bay
      </span>
    ),
  },
  {
    value: "America/Campo_Grande",
    label: "(GMT-04:00) America/Campo_Grande",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Campo_Grande
      </span>
    ),
  },
  {
    value: "America/Cancun",
    label: "(GMT-05:00) America/Cancun",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Cancun
      </span>
    ),
  },
  {
    value: "America/Caracas",
    label: "(GMT-04:00) America/Caracas",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Caracas
      </span>
    ),
  },
  {
    value: "America/Catamarca",
    label: "(GMT-03:00) America/Catamarca",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Catamarca
      </span>
    ),
  },
  {
    value: "America/Cayenne",
    label: "(GMT-03:00) America/Cayenne",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Cayenne
      </span>
    ),
  },
  {
    value: "America/Cayman",
    label: "(GMT-05:00) America/Cayman",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Cayman
      </span>
    ),
  },
  {
    value: "America/Chihuahua",
    label: "(GMT-06:00) America/Chihuahua",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Chihuahua
      </span>
    ),
  },
  {
    value: "America/Coral_Harbour",
    label: "(GMT-05:00) America/Coral_Harbour",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Coral_Harbour
      </span>
    ),
  },
  {
    value: "America/Cordoba",
    label: "(GMT-03:00) America/Cordoba",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Cordoba
      </span>
    ),
  },
  {
    value: "America/Costa_Rica",
    label: "(GMT-06:00) America/Costa_Rica",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Costa_Rica
      </span>
    ),
  },
  {
    value: "America/Creston",
    label: "(GMT-07:00) America/Creston",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Creston
      </span>
    ),
  },
  {
    value: "America/Cuiaba",
    label: "(GMT-04:00) America/Cuiaba",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Cuiaba
      </span>
    ),
  },
  {
    value: "America/Curacao",
    label: "(GMT-04:00) America/Curacao",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Curacao
      </span>
    ),
  },
  {
    value: "America/Danmarkshavn",
    label: "(GMT+00:00) America/Danmarkshavn",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) America/Danmarkshavn
      </span>
    ),
  },
  {
    value: "America/Dawson",
    label: "(GMT-07:00) America/Dawson",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Dawson
      </span>
    ),
  },
  {
    value: "America/Dawson_Creek",
    label: "(GMT-07:00) America/Dawson_Creek",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Dawson_Creek
      </span>
    ),
  },
  {
    value: "America/Detroit",
    label: "(GMT-04:00) America/Detroit",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Detroit
      </span>
    ),
  },
  {
    value: "America/Dominica",
    label: "(GMT-04:00) America/Dominica",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Dominica
      </span>
    ),
  },
  {
    value: "America/Edmonton",
    label: "(GMT-06:00) America/Edmonton",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Edmonton
      </span>
    ),
  },
  {
    value: "America/Eirunepe",
    label: "(GMT-05:00) America/Eirunepe",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Eirunepe
      </span>
    ),
  },
  {
    value: "America/El_Salvador",
    label: "(GMT-06:00) America/El_Salvador",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/El_Salvador
      </span>
    ),
  },
  {
    value: "America/Ensenada",
    label: "(GMT-07:00) America/Ensenada",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Ensenada
      </span>
    ),
  },
  {
    value: "America/Fort_Nelson",
    label: "(GMT-07:00) America/Fort_Nelson",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Fort_Nelson
      </span>
    ),
  },
  {
    value: "America/Fort_Wayne",
    label: "(GMT-04:00) America/Fort_Wayne",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Fort_Wayne
      </span>
    ),
  },
  {
    value: "America/Fortaleza",
    label: "(GMT-03:00) America/Fortaleza",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Fortaleza
      </span>
    ),
  },
  {
    value: "America/Glace_Bay",
    label: "(GMT-03:00) America/Glace_Bay",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Glace_Bay
      </span>
    ),
  },
  {
    value: "America/Godthab",
    label: "(GMT-01:00) America/Godthab",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-01:00) America/Godthab
      </span>
    ),
  },
  {
    value: "America/Goose_Bay",
    label: "(GMT-03:00) America/Goose_Bay",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Goose_Bay
      </span>
    ),
  },
  {
    value: "America/Grand_Turk",
    label: "(GMT-04:00) America/Grand_Turk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Grand_Turk
      </span>
    ),
  },
  {
    value: "America/Grenada",
    label: "(GMT-04:00) America/Grenada",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Grenada
      </span>
    ),
  },
  {
    value: "America/Guadeloupe",
    label: "(GMT-04:00) America/Guadeloupe",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Guadeloupe
      </span>
    ),
  },
  {
    value: "America/Guatemala",
    label: "(GMT-06:00) America/Guatemala",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Guatemala
      </span>
    ),
  },
  {
    value: "America/Guayaquil",
    label: "(GMT-05:00) America/Guayaquil",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Guayaquil
      </span>
    ),
  },
  {
    value: "America/Guyana",
    label: "(GMT-04:00) America/Guyana",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Guyana
      </span>
    ),
  },
  {
    value: "America/Havana",
    label: "(GMT-04:00) America/Havana",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Havana
      </span>
    ),
  },
  {
    value: "America/Hermosillo",
    label: "(GMT-07:00) America/Hermosillo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Hermosillo
      </span>
    ),
  },
  {
    value: "America/Indiana/Indianapolis",
    label: "(GMT-04:00) America/Indiana/Indianapolis",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Indiana/Indianapolis
      </span>
    ),
  },
  {
    value: "America/Indiana/Knox",
    label: "(GMT-05:00) America/Indiana/Knox",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Indiana/Knox
      </span>
    ),
  },
  {
    value: "America/Indiana/Marengo",
    label: "(GMT-04:00) America/Indiana/Marengo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Indiana/Marengo
      </span>
    ),
  },
  {
    value: "America/Indiana/Petersburg",
    label: "(GMT-04:00) America/Indiana/Petersburg",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Indiana/Petersburg
      </span>
    ),
  },
  {
    value: "America/Indiana/Tell_City",
    label: "(GMT-05:00) America/Indiana/Tell_City",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Indiana/Tell_City
      </span>
    ),
  },
  {
    value: "America/Indiana/Vevay",
    label: "(GMT-04:00) America/Indiana/Vevay",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Indiana/Vevay
      </span>
    ),
  },
  {
    value: "America/Indiana/Vincennes",
    label: "(GMT-04:00) America/Indiana/Vincennes",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Indiana/Vincennes
      </span>
    ),
  },
  {
    value: "America/Indiana/Winamac",
    label: "(GMT-04:00) America/Indiana/Winamac",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Indiana/Winamac
      </span>
    ),
  },
  {
    value: "America/Indianapolis",
    label: "(GMT-04:00) America/Indianapolis",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Indianapolis
      </span>
    ),
  },
  {
    value: "America/Inuvik",
    label: "(GMT-06:00) America/Inuvik",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Inuvik
      </span>
    ),
  },
  {
    value: "America/Iqaluit",
    label: "(GMT-04:00) America/Iqaluit",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Iqaluit
      </span>
    ),
  },
  {
    value: "America/Jamaica",
    label: "(GMT-05:00) America/Jamaica",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Jamaica
      </span>
    ),
  },
  {
    value: "America/Jujuy",
    label: "(GMT-03:00) America/Jujuy",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Jujuy
      </span>
    ),
  },
  {
    value: "America/Kentucky/Louisville",
    label: "(GMT-04:00) America/Kentucky/Louisville",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Kentucky/Louisville
      </span>
    ),
  },
  {
    value: "America/Kentucky/Monticello",
    label: "(GMT-04:00) America/Kentucky/Monticello",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Kentucky/Monticello
      </span>
    ),
  },
  {
    value: "America/Knox_IN",
    label: "(GMT-05:00) America/Knox_IN",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Knox_IN
      </span>
    ),
  },
  {
    value: "America/Kralendijk",
    label: "(GMT-04:00) America/Kralendijk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Kralendijk
      </span>
    ),
  },
  {
    value: "America/La_Paz",
    label: "(GMT-04:00) America/La_Paz",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/La_Paz
      </span>
    ),
  },
  {
    value: "America/Lima",
    label: "(GMT-05:00) America/Lima",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Lima
      </span>
    ),
  },
  {
    value: "America/Louisville",
    label: "(GMT-04:00) America/Louisville",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Louisville
      </span>
    ),
  },
  {
    value: "America/Lower_Princes",
    label: "(GMT-04:00) America/Lower_Princes",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Lower_Princes
      </span>
    ),
  },
  {
    value: "America/Maceio",
    label: "(GMT-03:00) America/Maceio",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Maceio
      </span>
    ),
  },
  {
    value: "America/Managua",
    label: "(GMT-06:00) America/Managua",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Managua
      </span>
    ),
  },
  {
    value: "America/Manaus",
    label: "(GMT-04:00) America/Manaus",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Manaus
      </span>
    ),
  },
  {
    value: "America/Marigot",
    label: "(GMT-04:00) America/Marigot",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Marigot
      </span>
    ),
  },
  {
    value: "America/Martinique",
    label: "(GMT-04:00) America/Martinique",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Martinique
      </span>
    ),
  },
  {
    value: "America/Matamoros",
    label: "(GMT-05:00) America/Matamoros",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Matamoros
      </span>
    ),
  },
  {
    value: "America/Mazatlan",
    label: "(GMT-07:00) America/Mazatlan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Mazatlan
      </span>
    ),
  },
  {
    value: "America/Mendoza",
    label: "(GMT-03:00) America/Mendoza",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Mendoza
      </span>
    ),
  },
  {
    value: "America/Menominee",
    label: "(GMT-05:00) America/Menominee",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Menominee
      </span>
    ),
  },
  {
    value: "America/Merida",
    label: "(GMT-06:00) America/Merida",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Merida
      </span>
    ),
  },
  {
    value: "America/Mexico_City",
    label: "(GMT-06:00) America/Mexico_City",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Mexico_City
      </span>
    ),
  },
  {
    value: "America/Miquelon",
    label: "(GMT-02:00) America/Miquelon",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-02:00) America/Miquelon
      </span>
    ),
  },
  {
    value: "America/Moncton",
    label: "(GMT-03:00) America/Moncton",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Moncton
      </span>
    ),
  },
  {
    value: "America/Monterrey",
    label: "(GMT-06:00) America/Monterrey",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Monterrey
      </span>
    ),
  },
  {
    value: "America/Montevideo",
    label: "(GMT-03:00) America/Montevideo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Montevideo
      </span>
    ),
  },
  {
    value: "America/Montreal",
    label: "(GMT-04:00) America/Montreal",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Montreal
      </span>
    ),
  },
  {
    value: "America/Montserrat",
    label: "(GMT-04:00) America/Montserrat",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Montserrat
      </span>
    ),
  },
  {
    value: "America/Nassau",
    label: "(GMT-04:00) America/Nassau",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Nassau
      </span>
    ),
  },
  {
    value: "America/Nipigon",
    label: "(GMT-04:00) America/Nipigon",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Nipigon
      </span>
    ),
  },
  {
    value: "America/Noronha",
    label: "(GMT-02:00) America/Noronha",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-02:00) America/Noronha
      </span>
    ),
  },
  {
    value: "America/North_Dakota/Beulah",
    label: "(GMT-05:00) America/North_Dakota/Beulah",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/North_Dakota/Beulah
      </span>
    ),
  },
  {
    value: "America/North_Dakota/Center",
    label: "(GMT-05:00) America/North_Dakota/Center",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/North_Dakota/Center
      </span>
    ),
  },
  {
    value: "America/North_Dakota/New_Salem",
    label: "(GMT-05:00) America/North_Dakota/New_Salem",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/North_Dakota/New_Salem
      </span>
    ),
  },
  {
    value: "America/Nuuk",
    label: "(GMT-01:00) America/Nuuk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-01:00) America/Nuuk
      </span>
    ),
  },
  {
    value: "America/Ojinaga",
    label: "(GMT-05:00) America/Ojinaga",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Ojinaga
      </span>
    ),
  },
  {
    value: "America/Panama",
    label: "(GMT-05:00) America/Panama",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Panama
      </span>
    ),
  },
  {
    value: "America/Pangnirtung",
    label: "(GMT-04:00) America/Pangnirtung",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Pangnirtung
      </span>
    ),
  },
  {
    value: "America/Paramaribo",
    label: "(GMT-03:00) America/Paramaribo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Paramaribo
      </span>
    ),
  },
  {
    value: "America/Port-au-Prince",
    label: "(GMT-04:00) America/Port-au-Prince",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Port-au-Prince
      </span>
    ),
  },
  {
    value: "America/Port_of_Spain",
    label: "(GMT-04:00) America/Port_of_Spain",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Port_of_Spain
      </span>
    ),
  },
  {
    value: "America/Porto_Acre",
    label: "(GMT-05:00) America/Porto_Acre",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Porto_Acre
      </span>
    ),
  },
  {
    value: "America/Porto_Velho",
    label: "(GMT-04:00) America/Porto_Velho",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Porto_Velho
      </span>
    ),
  },
  {
    value: "America/Puerto_Rico",
    label: "(GMT-04:00) America/Puerto_Rico",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Puerto_Rico
      </span>
    ),
  },
  {
    value: "America/Punta_Arenas",
    label: "(GMT-03:00) America/Punta_Arenas",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Punta_Arenas
      </span>
    ),
  },
  {
    value: "America/Rainy_River",
    label: "(GMT-05:00) America/Rainy_River",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Rainy_River
      </span>
    ),
  },
  {
    value: "America/Rankin_Inlet",
    label: "(GMT-05:00) America/Rankin_Inlet",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Rankin_Inlet
      </span>
    ),
  },
  {
    value: "America/Recife",
    label: "(GMT-03:00) America/Recife",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Recife
      </span>
    ),
  },
  {
    value: "America/Regina",
    label: "(GMT-06:00) America/Regina",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Regina
      </span>
    ),
  },
  {
    value: "America/Resolute",
    label: "(GMT-05:00) America/Resolute",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Resolute
      </span>
    ),
  },
  {
    value: "America/Rio_Branco",
    label: "(GMT-05:00) America/Rio_Branco",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Rio_Branco
      </span>
    ),
  },
  {
    value: "America/Rosario",
    label: "(GMT-03:00) America/Rosario",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Rosario
      </span>
    ),
  },
  {
    value: "America/Santa_Isabel",
    label: "(GMT-07:00) America/Santa_Isabel",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Santa_Isabel
      </span>
    ),
  },
  {
    value: "America/Santarem",
    label: "(GMT-03:00) America/Santarem",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Santarem
      </span>
    ),
  },
  {
    value: "America/Santiago",
    label: "(GMT-04:00) America/Santiago",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Santiago
      </span>
    ),
  },
  {
    value: "America/Santo_Domingo",
    label: "(GMT-04:00) America/Santo_Domingo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Santo_Domingo
      </span>
    ),
  },
  {
    value: "America/Sao_Paulo",
    label: "(GMT-03:00) America/Sao_Paulo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Sao_Paulo
      </span>
    ),
  },
  {
    value: "America/Scoresbysund",
    label: "(GMT-01:00) America/Scoresbysund",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-01:00) America/Scoresbysund
      </span>
    ),
  },
  {
    value: "America/Shiprock",
    label: "(GMT-06:00) America/Shiprock",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Shiprock
      </span>
    ),
  },
  {
    value: "America/St_Barthelemy",
    label: "(GMT-04:00) America/St_Barthelemy",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/St_Barthelemy
      </span>
    ),
  },
  {
    value: "America/St_Kitts",
    label: "(GMT-04:00) America/St_Kitts",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/St_Kitts
      </span>
    ),
  },
  {
    value: "America/St_Lucia",
    label: "(GMT-04:00) America/St_Lucia",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/St_Lucia
      </span>
    ),
  },
  {
    value: "America/St_Thomas",
    label: "(GMT-04:00) America/St_Thomas",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/St_Thomas
      </span>
    ),
  },
  {
    value: "America/St_Vincent",
    label: "(GMT-04:00) America/St_Vincent",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/St_Vincent
      </span>
    ),
  },
  {
    value: "America/Swift_Current",
    label: "(GMT-06:00) America/Swift_Current",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Swift_Current
      </span>
    ),
  },
  {
    value: "America/Tegucigalpa",
    label: "(GMT-06:00) America/Tegucigalpa",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Tegucigalpa
      </span>
    ),
  },
  {
    value: "America/Thule",
    label: "(GMT-03:00) America/Thule",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) America/Thule
      </span>
    ),
  },
  {
    value: "America/Thunder_Bay",
    label: "(GMT-04:00) America/Thunder_Bay",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Thunder_Bay
      </span>
    ),
  },
  {
    value: "America/Toronto",
    label: "(GMT-04:00) America/Toronto",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Toronto
      </span>
    ),
  },
  {
    value: "America/Tortola",
    label: "(GMT-04:00) America/Tortola",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Tortola
      </span>
    ),
  },
  {
    value: "America/Virgin",
    label: "(GMT-04:00) America/Virgin",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) America/Virgin
      </span>
    ),
  },
  {
    value: "America/Whitehorse",
    label: "(GMT-07:00) America/Whitehorse",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) America/Whitehorse
      </span>
    ),
  },
  {
    value: "America/Winnipeg",
    label: "(GMT-05:00) America/Winnipeg",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) America/Winnipeg
      </span>
    ),
  },
  {
    value: "America/Yellowknife",
    label: "(GMT-06:00) America/Yellowknife",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) America/Yellowknife
      </span>
    ),
  },
  {
    value: "Antarctica/Casey",
    label: "(GMT+11:00) Antarctica/Casey",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Antarctica/Casey
      </span>
    ),
  },
  {
    value: "Antarctica/Davis",
    label: "(GMT+07:00) Antarctica/Davis",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Antarctica/Davis
      </span>
    ),
  },
  {
    value: "Antarctica/DumontDUrville",
    label: "(GMT+10:00) Antarctica/DumontDUrville",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Antarctica/DumontDUrville
      </span>
    ),
  },
  {
    value: "Antarctica/Macquarie",
    label: "(GMT+11:00) Antarctica/Macquarie",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Antarctica/Macquarie
      </span>
    ),
  },
  {
    value: "Antarctica/Mawson",
    label: "(GMT+05:00) Antarctica/Mawson",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Antarctica/Mawson
      </span>
    ),
  },
  {
    value: "Antarctica/McMurdo",
    label: "(GMT+12:00) Antarctica/McMurdo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Antarctica/McMurdo
      </span>
    ),
  },
  {
    value: "Antarctica/Palmer",
    label: "(GMT-03:00) Antarctica/Palmer",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) Antarctica/Palmer
      </span>
    ),
  },
  {
    value: "Antarctica/Rothera",
    label: "(GMT-03:00) Antarctica/Rothera",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) Antarctica/Rothera
      </span>
    ),
  },
  {
    value: "Antarctica/South_Pole",
    label: "(GMT+12:00) Antarctica/South_Pole",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Antarctica/South_Pole
      </span>
    ),
  },
  {
    value: "Antarctica/Syowa",
    label: "(GMT+03:00) Antarctica/Syowa",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Antarctica/Syowa
      </span>
    ),
  },
  {
    value: "Antarctica/Troll",
    label: "(GMT+02:00) Antarctica/Troll",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Antarctica/Troll
      </span>
    ),
  },
  {
    value: "Antarctica/Vostok",
    label: "(GMT+06:00) Antarctica/Vostok",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Antarctica/Vostok
      </span>
    ),
  },
  {
    value: "Arctic/Longyearbyen",
    label: "(GMT+02:00) Arctic/Longyearbyen",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Arctic/Longyearbyen
      </span>
    ),
  },
  {
    value: "Asia/Aden",
    label: "(GMT+03:00) Asia/Aden",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Aden
      </span>
    ),
  },
  {
    value: "Asia/Almaty",
    label: "(GMT+06:00) Asia/Almaty",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Asia/Almaty
      </span>
    ),
  },
  {
    value: "Asia/Amman",
    label: "(GMT+03:00) Asia/Amman",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Amman
      </span>
    ),
  },
  {
    value: "Asia/Anadyr",
    label: "(GMT+12:00) Asia/Anadyr",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Asia/Anadyr
      </span>
    ),
  },
  {
    value: "Asia/Aqtau",
    label: "(GMT+05:00) Asia/Aqtau",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Aqtau
      </span>
    ),
  },
  {
    value: "Asia/Aqtobe",
    label: "(GMT+05:00) Asia/Aqtobe",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Aqtobe
      </span>
    ),
  },
  {
    value: "Asia/Ashgabat",
    label: "(GMT+05:00) Asia/Ashgabat",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Ashgabat
      </span>
    ),
  },
  {
    value: "Asia/Ashkhabad",
    label: "(GMT+05:00) Asia/Ashkhabad",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Ashkhabad
      </span>
    ),
  },
  {
    value: "Asia/Atyrau",
    label: "(GMT+05:00) Asia/Atyrau",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Atyrau
      </span>
    ),
  },
  {
    value: "Asia/Baghdad",
    label: "(GMT+03:00) Asia/Baghdad",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Baghdad
      </span>
    ),
  },
  {
    value: "Asia/Bahrain",
    label: "(GMT+03:00) Asia/Bahrain",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Bahrain
      </span>
    ),
  },
  {
    value: "Asia/Baku",
    label: "(GMT+04:00) Asia/Baku",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Asia/Baku
      </span>
    ),
  },
  {
    value: "Asia/Barnaul",
    label: "(GMT+07:00) Asia/Barnaul",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Barnaul
      </span>
    ),
  },
  {
    value: "Asia/Beirut",
    label: "(GMT+03:00) Asia/Beirut",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Beirut
      </span>
    ),
  },
  {
    value: "Asia/Bishkek",
    label: "(GMT+06:00) Asia/Bishkek",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Asia/Bishkek
      </span>
    ),
  },
  {
    value: "Asia/Brunei",
    label: "(GMT+08:00) Asia/Brunei",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Brunei
      </span>
    ),
  },
  {
    value: "Asia/Calcutta",
    label: "(GMT+05:30) Asia/Calcutta",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:30) Asia/Calcutta
      </span>
    ),
  },
  {
    value: "Asia/Chita",
    label: "(GMT+09:00) Asia/Chita",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) Asia/Chita
      </span>
    ),
  },
  {
    value: "Asia/Choibalsan",
    label: "(GMT+08:00) Asia/Choibalsan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Choibalsan
      </span>
    ),
  },
  {
    value: "Asia/Chongqing",
    label: "(GMT+08:00) Asia/Chongqing",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Chongqing
      </span>
    ),
  },
  {
    value: "Asia/Chungking",
    label: "(GMT+08:00) Asia/Chungking",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Chungking
      </span>
    ),
  },
  {
    value: "Asia/Colombo",
    label: "(GMT+05:30) Asia/Colombo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:30) Asia/Colombo
      </span>
    ),
  },
  {
    value: "Asia/Dacca",
    label: "(GMT+06:00) Asia/Dacca",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Asia/Dacca
      </span>
    ),
  },
  {
    value: "Asia/Damascus",
    label: "(GMT+03:00) Asia/Damascus",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Damascus
      </span>
    ),
  },
  {
    value: "Asia/Dili",
    label: "(GMT+09:00) Asia/Dili",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) Asia/Dili
      </span>
    ),
  },
  {
    value: "Asia/Dushanbe",
    label: "(GMT+05:00) Asia/Dushanbe",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Dushanbe
      </span>
    ),
  },
  {
    value: "Asia/Famagusta",
    label: "(GMT+03:00) Asia/Famagusta",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Famagusta
      </span>
    ),
  },
  {
    value: "Asia/Gaza",
    label: "(GMT+03:00) Asia/Gaza",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Gaza
      </span>
    ),
  },
  {
    value: "Asia/Harbin",
    label: "(GMT+08:00) Asia/Harbin",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Harbin
      </span>
    ),
  },
  {
    value: "Asia/Hebron",
    label: "(GMT+03:00) Asia/Hebron",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Hebron
      </span>
    ),
  },
  {
    value: "Asia/Ho_Chi_Minh",
    label: "(GMT+07:00) Asia/Ho_Chi_Minh",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Ho_Chi_Minh
      </span>
    ),
  },
  {
    value: "Asia/Hong_Kong",
    label: "(GMT+08:00) Asia/Hong_Kong",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Hong_Kong
      </span>
    ),
  },
  {
    value: "Asia/Hovd",
    label: "(GMT+07:00) Asia/Hovd",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Hovd
      </span>
    ),
  },
  {
    value: "Asia/Irkutsk",
    label: "(GMT+08:00) Asia/Irkutsk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Irkutsk
      </span>
    ),
  },
  {
    value: "Asia/Istanbul",
    label: "(GMT+03:00) Asia/Istanbul",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Istanbul
      </span>
    ),
  },
  {
    value: "Asia/Jakarta",
    label: "(GMT+07:00) Asia/Jakarta",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Jakarta
      </span>
    ),
  },
  {
    value: "Asia/Jayapura",
    label: "(GMT+09:00) Asia/Jayapura",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) Asia/Jayapura
      </span>
    ),
  },
  {
    value: "Asia/Jerusalem",
    label: "(GMT+03:00) Asia/Jerusalem",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Jerusalem
      </span>
    ),
  },
  {
    value: "Asia/Kabul",
    label: "(GMT+04:30) Asia/Kabul",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:30) Asia/Kabul
      </span>
    ),
  },
  {
    value: "Asia/Kamchatka",
    label: "(GMT+12:00) Asia/Kamchatka",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Asia/Kamchatka
      </span>
    ),
  },
  {
    value: "Asia/Kashgar",
    label: "(GMT+06:00) Asia/Kashgar",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Asia/Kashgar
      </span>
    ),
  },
  {
    value: "Asia/Kathmandu",
    label: "(GMT+05:45) Asia/Kathmandu",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:45) Asia/Kathmandu
      </span>
    ),
  },
  {
    value: "Asia/Katmandu",
    label: "(GMT+05:45) Asia/Katmandu",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:45) Asia/Katmandu
      </span>
    ),
  },
  {
    value: "Asia/Khandyga",
    label: "(GMT+09:00) Asia/Khandyga",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) Asia/Khandyga
      </span>
    ),
  },
  {
    value: "Asia/Krasnoyarsk",
    label: "(GMT+07:00) Asia/Krasnoyarsk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Krasnoyarsk
      </span>
    ),
  },
  {
    value: "Asia/Kuala_Lumpur",
    label: "(GMT+08:00) Asia/Kuala_Lumpur",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Kuala_Lumpur
      </span>
    ),
  },
  {
    value: "Asia/Kuching",
    label: "(GMT+08:00) Asia/Kuching",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Kuching
      </span>
    ),
  },
  {
    value: "Asia/Kuwait",
    label: "(GMT+03:00) Asia/Kuwait",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Kuwait
      </span>
    ),
  },
  {
    value: "Asia/Macao",
    label: "(GMT+08:00) Asia/Macao",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Macao
      </span>
    ),
  },
  {
    value: "Asia/Macau",
    label: "(GMT+08:00) Asia/Macau",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Macau
      </span>
    ),
  },
  {
    value: "Asia/Magadan",
    label: "(GMT+11:00) Asia/Magadan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Asia/Magadan
      </span>
    ),
  },
  {
    value: "Asia/Makassar",
    label: "(GMT+08:00) Asia/Makassar",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Makassar
      </span>
    ),
  },
  {
    value: "Asia/Manila",
    label: "(GMT+08:00) Asia/Manila",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Manila
      </span>
    ),
  },
  {
    value: "Asia/Muscat",
    label: "(GMT+04:00) Asia/Muscat",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Asia/Muscat
      </span>
    ),
  },
  {
    value: "Asia/Nicosia",
    label: "(GMT+03:00) Asia/Nicosia",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Nicosia
      </span>
    ),
  },
  {
    value: "Asia/Novokuznetsk",
    label: "(GMT+07:00) Asia/Novokuznetsk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Novokuznetsk
      </span>
    ),
  },
  {
    value: "Asia/Novosibirsk",
    label: "(GMT+07:00) Asia/Novosibirsk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Novosibirsk
      </span>
    ),
  },
  {
    value: "Asia/Omsk",
    label: "(GMT+06:00) Asia/Omsk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Asia/Omsk
      </span>
    ),
  },
  {
    value: "Asia/Oral",
    label: "(GMT+05:00) Asia/Oral",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Oral
      </span>
    ),
  },
  {
    value: "Asia/Phnom_Penh",
    label: "(GMT+07:00) Asia/Phnom_Penh",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Phnom_Penh
      </span>
    ),
  },
  {
    value: "Asia/Pontianak",
    label: "(GMT+07:00) Asia/Pontianak",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Pontianak
      </span>
    ),
  },
  {
    value: "Asia/Pyongyang",
    label: "(GMT+09:00) Asia/Pyongyang",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) Asia/Pyongyang
      </span>
    ),
  },
  {
    value: "Asia/Qatar",
    label: "(GMT+03:00) Asia/Qatar",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Qatar
      </span>
    ),
  },
  {
    value: "Asia/Qostanay",
    label: "(GMT+06:00) Asia/Qostanay",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Asia/Qostanay
      </span>
    ),
  },
  {
    value: "Asia/Qyzylorda",
    label: "(GMT+05:00) Asia/Qyzylorda",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Qyzylorda
      </span>
    ),
  },
  {
    value: "Asia/Rangoon",
    label: "(GMT+06:30) Asia/Rangoon",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:30) Asia/Rangoon
      </span>
    ),
  },
  {
    value: "Asia/Riyadh",
    label: "(GMT+03:00) Asia/Riyadh",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Riyadh
      </span>
    ),
  },
  {
    value: "Asia/Saigon",
    label: "(GMT+07:00) Asia/Saigon",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Saigon
      </span>
    ),
  },
  {
    value: "Asia/Sakhalin",
    label: "(GMT+11:00) Asia/Sakhalin",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Asia/Sakhalin
      </span>
    ),
  },
  {
    value: "Asia/Samarkand",
    label: "(GMT+05:00) Asia/Samarkand",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Samarkand
      </span>
    ),
  },
  {
    value: "Asia/Seoul",
    label: "(GMT+09:00) Asia/Seoul",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) Asia/Seoul
      </span>
    ),
  },
  {
    value: "Asia/Singapore",
    label: "(GMT+08:00) Asia/Singapore",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Singapore
      </span>
    ),
  },
  {
    value: "Asia/Srednekolymsk",
    label: "(GMT+11:00) Asia/Srednekolymsk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Asia/Srednekolymsk
      </span>
    ),
  },
  {
    value: "Asia/Taipei",
    label: "(GMT+08:00) Asia/Taipei",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Taipei
      </span>
    ),
  },
  {
    value: "Asia/Tashkent",
    label: "(GMT+05:00) Asia/Tashkent",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Tashkent
      </span>
    ),
  },
  {
    value: "Asia/Tbilisi",
    label: "(GMT+04:00) Asia/Tbilisi",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Asia/Tbilisi
      </span>
    ),
  },
  {
    value: "Asia/Tehran",
    label: "(GMT+03:30) Asia/Tehran",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:30) Asia/Tehran
      </span>
    ),
  },
  {
    value: "Asia/Tel_Aviv",
    label: "(GMT+03:00) Asia/Tel_Aviv",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Asia/Tel_Aviv
      </span>
    ),
  },
  {
    value: "Asia/Thimbu",
    label: "(GMT+06:00) Asia/Thimbu",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Asia/Thimbu
      </span>
    ),
  },
  {
    value: "Asia/Thimphu",
    label: "(GMT+06:00) Asia/Thimphu",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Asia/Thimphu
      </span>
    ),
  },
  {
    value: "Asia/Tomsk",
    label: "(GMT+07:00) Asia/Tomsk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Tomsk
      </span>
    ),
  },
  {
    value: "Asia/Ujung_Pandang",
    label: "(GMT+08:00) Asia/Ujung_Pandang",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Ujung_Pandang
      </span>
    ),
  },
  {
    value: "Asia/Ulaanbaatar",
    label: "(GMT+08:00) Asia/Ulaanbaatar",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Ulaanbaatar
      </span>
    ),
  },
  {
    value: "Asia/Ulan_Bator",
    label: "(GMT+08:00) Asia/Ulan_Bator",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Ulan_Bator
      </span>
    ),
  },
  {
    value: "Asia/Urumqi",
    label: "(GMT+06:00) Asia/Urumqi",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Asia/Urumqi
      </span>
    ),
  },
  {
    value: "Asia/Ust-Nera",
    label: "(GMT+10:00) Asia/Ust-Nera",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Asia/Ust-Nera
      </span>
    ),
  },
  {
    value: "Asia/Vientiane",
    label: "(GMT+07:00) Asia/Vientiane",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Asia/Vientiane
      </span>
    ),
  },
  {
    value: "Asia/Vladivostok",
    label: "(GMT+10:00) Asia/Vladivostok",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Asia/Vladivostok
      </span>
    ),
  },
  {
    value: "Asia/Yakutsk",
    label: "(GMT+09:00) Asia/Yakutsk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) Asia/Yakutsk
      </span>
    ),
  },
  {
    value: "Asia/Yangon",
    label: "(GMT+06:30) Asia/Yangon",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:30) Asia/Yangon
      </span>
    ),
  },
  {
    value: "Asia/Yekaterinburg",
    label: "(GMT+05:00) Asia/Yekaterinburg",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Asia/Yekaterinburg
      </span>
    ),
  },
  {
    value: "Asia/Yerevan",
    label: "(GMT+04:00) Asia/Yerevan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Asia/Yerevan
      </span>
    ),
  },
  // Atlantic
  {
    value: "Atlantic/Bermuda",
    label: "(GMT-03:00) Atlantic/Bermuda",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) Atlantic/Bermuda
      </span>
    ),
  },
  {
    value: "Atlantic/Canary",
    label: "(GMT+01:00) Atlantic/Canary",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Atlantic/Canary
      </span>
    ),
  },
  {
    value: "Atlantic/Cape_Verde",
    label: "(GMT-01:00) Atlantic/Cape_Verde",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-01:00) Atlantic/Cape_Verde
      </span>
    ),
  },
  {
    value: "Atlantic/Faeroe",
    label: "(GMT+01:00) Atlantic/Faeroe",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Atlantic/Faeroe
      </span>
    ),
  },
  {
    value: "Atlantic/Faroe",
    label: "(GMT+01:00) Atlantic/Faroe",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Atlantic/Faroe
      </span>
    ),
  },
  {
    value: "Atlantic/Jan_Mayen",
    label: "(GMT+02:00) Atlantic/Jan_Mayen",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Atlantic/Jan_Mayen
      </span>
    ),
  },
  {
    value: "Atlantic/Madeira",
    label: "(GMT+01:00) Atlantic/Madeira",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Atlantic/Madeira
      </span>
    ),
  },
  {
    value: "Atlantic/Reykjavik",
    label: "(GMT+00:00) Atlantic/Reykjavik",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Atlantic/Reykjavik
      </span>
    ),
  },
  {
    value: "Atlantic/South_Georgia",
    label: "(GMT-02:00) Atlantic/South_Georgia",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-02:00) Atlantic/South_Georgia
      </span>
    ),
  },
  {
    value: "Atlantic/St_Helena",
    label: "(GMT+00:00) Atlantic/St_Helena",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Atlantic/St_Helena
      </span>
    ),
  },
  {
    value: "Atlantic/Stanley",
    label: "(GMT-03:00) Atlantic/Stanley",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) Atlantic/Stanley
      </span>
    ),
  },
  // Australia
  {
    value: "Australia/ACT",
    label: "(GMT+10:00) Australia/ACT",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/ACT
      </span>
    ),
  },
  {
    value: "Australia/Adelaide",
    label: "(GMT+09:30) Australia/Adelaide",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:30) Australia/Adelaide
      </span>
    ),
  },
  {
    value: "Australia/Brisbane",
    label: "(GMT+10:00) Australia/Brisbane",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/Brisbane
      </span>
    ),
  },
  {
    value: "Australia/Broken_Hill",
    label: "(GMT+09:30) Australia/Broken_Hill",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:30) Australia/Broken_Hill
      </span>
    ),
  },
  {
    value: "Australia/Canberra",
    label: "(GMT+10:00) Australia/Canberra",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/Canberra
      </span>
    ),
  },
  {
    value: "Australia/Currie",
    label: "(GMT+10:00) Australia/Currie",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/Currie
      </span>
    ),
  },
  {
    value: "Australia/Darwin",
    label: "(GMT+09:30) Australia/Darwin",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:30) Australia/Darwin
      </span>
    ),
  },
  {
    value: "Australia/Eucla",
    label: "(GMT+08:45) Australia/Eucla",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:45) Australia/Eucla
      </span>
    ),
  },
  {
    value: "Australia/Hobart",
    label: "(GMT+10:00) Australia/Hobart",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/Hobart
      </span>
    ),
  },
  {
    value: "Australia/LHI",
    label: "(GMT+10:30) Australia/LHI",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:30) Australia/LHI
      </span>
    ),
  },
  {
    value: "Australia/Lindeman",
    label: "(GMT+10:00) Australia/Lindeman",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/Lindeman
      </span>
    ),
  },
  {
    value: "Australia/Lord_Howe",
    label: "(GMT+10:30) Australia/Lord_Howe",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:30) Australia/Lord_Howe
      </span>
    ),
  },
  {
    value: "Australia/Melbourne",
    label: "(GMT+10:00) Australia/Melbourne",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/Melbourne
      </span>
    ),
  },
  {
    value: "Australia/NSW",
    label: "(GMT+10:00) Australia/NSW",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/NSW
      </span>
    ),
  },
  {
    value: "Australia/North",
    label: "(GMT+09:30) Australia/North",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:30) Australia/North
      </span>
    ),
  },
  {
    value: "Australia/Perth",
    label: "(GMT+08:00) Australia/Perth",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Australia/Perth
      </span>
    ),
  },
  {
    value: "Australia/Queensland",
    label: "(GMT+10:00) Australia/Queensland",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/Queensland
      </span>
    ),
  },
  {
    value: "Australia/South",
    label: "(GMT+09:30) Australia/South",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:30) Australia/South
      </span>
    ),
  },
  {
    value: "Australia/Tasmania",
    label: "(GMT+10:00) Australia/Tasmania",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/Tasmania
      </span>
    ),
  },
  {
    value: "Australia/Victoria",
    label: "(GMT+10:00) Australia/Victoria",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/Victoria
      </span>
    ),
  },
  {
    value: "Australia/West",
    label: "(GMT+08:00) Australia/West",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Australia/West
      </span>
    ),
  },
  {
    value: "Australia/Yancowinna",
    label: "(GMT+09:30) Australia/Yancowinna",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:30) Australia/Yancowinna
      </span>
    ),
  },
  // Brazil
  {
    value: "Brazil/Acre",
    label: "(GMT-05:00) Brazil/Acre",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) Brazil/Acre
      </span>
    ),
  },
  {
    value: "Brazil/DeNoronha",
    label: "(GMT-02:00) Brazil/DeNoronha",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-02:00) Brazil/DeNoronha
      </span>
    ),
  },
  {
    value: "Brazil/East",
    label: "(GMT-03:00) Brazil/East",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) Brazil/East
      </span>
    ),
  },
  {
    value: "Brazil/West",
    label: "(GMT-04:00) Brazil/West",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) Brazil/West
      </span>
    ),
  },
  // Common timezone abbreviations
  {
    value: "CET",
    label: "(GMT+02:00) CET",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) CET
      </span>
    ),
  },
  {
    value: "CST6CDT",
    label: "(GMT-05:00) CST6CDT",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) CST6CDT
      </span>
    ),
  },
  {
    value: "Canada/Atlantic",
    label: "(GMT-03:00) Canada/Atlantic",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) Canada/Atlantic
      </span>
    ),
  },
  {
    value: "Canada/Central",
    label: "(GMT-05:00) Canada/Central",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) Canada/Central
      </span>
    ),
  },
  {
    value: "Canada/Eastern",
    label: "(GMT-04:00) Canada/Eastern",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) Canada/Eastern
      </span>
    ),
  },
  {
    value: "Canada/Mountain",
    label: "(GMT-06:00) Canada/Mountain",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) Canada/Mountain
      </span>
    ),
  },
  {
    value: "Canada/Newfoundland",
    label: "(GMT-02:30) Canada/Newfoundland",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-02:30) Canada/Newfoundland
      </span>
    ),
  },
  {
    value: "Canada/Pacific",
    label: "(GMT-07:00) Canada/Pacific",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) Canada/Pacific
      </span>
    ),
  },
  {
    value: "Canada/Saskatchewan",
    label: "(GMT-06:00) Canada/Saskatchewan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) Canada/Saskatchewan
      </span>
    ),
  },
  {
    value: "Canada/Yukon",
    label: "(GMT-07:00) Canada/Yukon",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) Canada/Yukon
      </span>
    ),
  },
  {
    value: "Chile/Continental",
    label: "(GMT-04:00) Chile/Continental",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) Chile/Continental
      </span>
    ),
  },
  {
    value: "Chile/EasterIsland",
    label: "(GMT-06:00) Chile/EasterIsland",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) Chile/EasterIsland
      </span>
    ),
  },
  {
    value: "Cuba",
    label: "(GMT-04:00) Cuba",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) Cuba
      </span>
    ),
  },
  {
    value: "EET",
    label: "(GMT+03:00) EET",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) EET
      </span>
    ),
  },
  {
    value: "EST",
    label: "(GMT-05:00) EST",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) EST
      </span>
    ),
  },
  {
    value: "EST5EDT",
    label: "(GMT-04:00) EST5EDT",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) EST5EDT
      </span>
    ),
  },
  {
    value: "Egypt",
    label: "(GMT+03:00) Egypt",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Egypt
      </span>
    ),
  },
  {
    value: "Eire",
    label: "(GMT+01:00) Eire",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Eire
      </span>
    ),
  },
  // Europe
  {
    value: "Europe/Amsterdam",
    label: "(GMT+02:00) Europe/Amsterdam",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Amsterdam
      </span>
    ),
  },
  {
    value: "Europe/Andorra",
    label: "(GMT+02:00) Europe/Andorra",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Andorra
      </span>
    ),
  },
  {
    value: "Europe/Astrakhan",
    label: "(GMT+04:00) Europe/Astrakhan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Europe/Astrakhan
      </span>
    ),
  },
  {
    value: "Europe/Athens",
    label: "(GMT+03:00) Europe/Athens",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Athens
      </span>
    ),
  },
  {
    value: "Europe/Belfast",
    label: "(GMT+01:00) Europe/Belfast",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Europe/Belfast
      </span>
    ),
  },
  {
    value: "Europe/Belgrade",
    label: "(GMT+02:00) Europe/Belgrade",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Belgrade
      </span>
    ),
  },
  {
    value: "Europe/Berlin",
    label: "(GMT+02:00) Europe/Berlin",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Berlin
      </span>
    ),
  },
  {
    value: "Europe/Bratislava",
    label: "(GMT+02:00) Europe/Bratislava",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Bratislava
      </span>
    ),
  },
  {
    value: "Europe/Brussels",
    label: "(GMT+02:00) Europe/Brussels",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Brussels
      </span>
    ),
  },
  {
    value: "Europe/Bucharest",
    label: "(GMT+03:00) Europe/Bucharest",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Bucharest
      </span>
    ),
  },
  {
    value: "Europe/Budapest",
    label: "(GMT+02:00) Europe/Budapest",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Budapest
      </span>
    ),
  },
  {
    value: "Europe/Busingen",
    label: "(GMT+02:00) Europe/Busingen",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Busingen
      </span>
    ),
  },
  {
    value: "Europe/Chisinau",
    label: "(GMT+03:00) Europe/Chisinau",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Chisinau
      </span>
    ),
  },
  {
    value: "Europe/Copenhagen",
    label: "(GMT+02:00) Europe/Copenhagen",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Copenhagen
      </span>
    ),
  },
  {
    value: "Europe/Dublin",
    label: "(GMT+01:00) Europe/Dublin",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Europe/Dublin
      </span>
    ),
  },
  {
    value: "Europe/Gibraltar",
    label: "(GMT+02:00) Europe/Gibraltar",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Gibraltar
      </span>
    ),
  },
  {
    value: "Europe/Guernsey",
    label: "(GMT+01:00) Europe/Guernsey",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Europe/Guernsey
      </span>
    ),
  },
  {
    value: "Europe/Helsinki",
    label: "(GMT+03:00) Europe/Helsinki",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Helsinki
      </span>
    ),
  },
  {
    value: "Europe/Isle_of_Man",
    label: "(GMT+01:00) Europe/Isle_of_Man",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Europe/Isle_of_Man
      </span>
    ),
  },
  {
    value: "Europe/Jersey",
    label: "(GMT+01:00) Europe/Jersey",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Europe/Jersey
      </span>
    ),
  },
  {
    value: "Europe/Kaliningrad",
    label: "(GMT+02:00) Europe/Kaliningrad",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Kaliningrad
      </span>
    ),
  },
  {
    value: "Europe/Kiev",
    label: "(GMT+03:00) Europe/Kiev",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Kiev
      </span>
    ),
  },
  {
    value: "Europe/Kirov",
    label: "(GMT+03:00) Europe/Kirov",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Kirov
      </span>
    ),
  },
  {
    value: "Europe/Lisbon",
    label: "(GMT+01:00) Europe/Lisbon",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Europe/Lisbon
      </span>
    ),
  },
  {
    value: "Europe/Ljubljana",
    label: "(GMT+02:00) Europe/Ljubljana",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Ljubljana
      </span>
    ),
  },
  {
    value: "Europe/Luxembourg",
    label: "(GMT+02:00) Europe/Luxembourg",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Luxembourg
      </span>
    ),
  },
  {
    value: "Europe/Madrid",
    label: "(GMT+02:00) Europe/Madrid",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Madrid
      </span>
    ),
  },
  {
    value: "Europe/Malta",
    label: "(GMT+02:00) Europe/Malta",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Malta
      </span>
    ),
  },
  {
    value: "Europe/Mariehamn",
    label: "(GMT+03:00) Europe/Mariehamn",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Mariehamn
      </span>
    ),
  },
  {
    value: "Europe/Minsk",
    label: "(GMT+03:00) Europe/Minsk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Minsk
      </span>
    ),
  },
  {
    value: "Europe/Monaco",
    label: "(GMT+02:00) Europe/Monaco",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Monaco
      </span>
    ),
  },
  {
    value: "Europe/Moscow",
    label: "(GMT+03:00) Europe/Moscow",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Moscow
      </span>
    ),
  },
  {
    value: "Europe/Nicosia",
    label: "(GMT+03:00) Europe/Nicosia",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Nicosia
      </span>
    ),
  },
  {
    value: "Europe/Oslo",
    label: "(GMT+02:00) Europe/Oslo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Oslo
      </span>
    ),
  },
  {
    value: "Europe/Podgorica",
    label: "(GMT+02:00) Europe/Podgorica",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Podgorica
      </span>
    ),
  },
  {
    value: "Europe/Prague",
    label: "(GMT+02:00) Europe/Prague",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Prague
      </span>
    ),
  },
  {
    value: "Europe/Riga",
    label: "(GMT+03:00) Europe/Riga",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Riga
      </span>
    ),
  },
  {
    value: "Europe/Rome",
    label: "(GMT+02:00) Europe/Rome",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Rome
      </span>
    ),
  },
  {
    value: "Europe/Samara",
    label: "(GMT+04:00) Europe/Samara",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Europe/Samara
      </span>
    ),
  },
  {
    value: "Europe/San_Marino",
    label: "(GMT+02:00) Europe/San_Marino",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/San_Marino
      </span>
    ),
  },
  {
    value: "Europe/Sarajevo",
    label: "(GMT+02:00) Europe/Sarajevo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Sarajevo
      </span>
    ),
  },
  {
    value: "Europe/Saratov",
    label: "(GMT+04:00) Europe/Saratov",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Europe/Saratov
      </span>
    ),
  },
  {
    value: "Europe/Simferopol",
    label: "(GMT+03:00) Europe/Simferopol",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Simferopol
      </span>
    ),
  },
  {
    value: "Europe/Skopje",
    label: "(GMT+02:00) Europe/Skopje",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Skopje
      </span>
    ),
  },
  {
    value: "Europe/Sofia",
    label: "(GMT+03:00) Europe/Sofia",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Sofia
      </span>
    ),
  },
  {
    value: "Europe/Stockholm",
    label: "(GMT+02:00) Europe/Stockholm",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Stockholm
      </span>
    ),
  },
  {
    value: "Europe/Tallinn",
    label: "(GMT+03:00) Europe/Tallinn",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Tallinn
      </span>
    ),
  },
  {
    value: "Europe/Tirane",
    label: "(GMT+02:00) Europe/Tirane",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Tirane
      </span>
    ),
  },
  {
    value: "Europe/Tiraspol",
    label: "(GMT+03:00) Europe/Tiraspol",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Tiraspol
      </span>
    ),
  },
  {
    value: "Europe/Ulyanovsk",
    label: "(GMT+04:00) Europe/Ulyanovsk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Europe/Ulyanovsk
      </span>
    ),
  },
  {
    value: "Europe/Uzhgorod",
    label: "(GMT+03:00) Europe/Uzhgorod",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Uzhgorod
      </span>
    ),
  },
  {
    value: "Europe/Vaduz",
    label: "(GMT+02:00) Europe/Vaduz",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Vaduz
      </span>
    ),
  },
  {
    value: "Europe/Vatican",
    label: "(GMT+02:00) Europe/Vatican",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Vatican
      </span>
    ),
  },
  {
    value: "Europe/Vienna",
    label: "(GMT+02:00) Europe/Vienna",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Vienna
      </span>
    ),
  },
  {
    value: "Europe/Vilnius",
    label: "(GMT+03:00) Europe/Vilnius",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Vilnius
      </span>
    ),
  },
  {
    value: "Europe/Volgograd",
    label: "(GMT+04:00) Europe/Volgograd",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Europe/Volgograd
      </span>
    ),
  },
  {
    value: "Europe/Warsaw",
    label: "(GMT+02:00) Europe/Warsaw",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Warsaw
      </span>
    ),
  },
  {
    value: "Europe/Zagreb",
    label: "(GMT+02:00) Europe/Zagreb",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Zagreb
      </span>
    ),
  },
  {
    value: "Europe/Zaporozhye",
    label: "(GMT+03:00) Europe/Zaporozhye",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Europe/Zaporozhye
      </span>
    ),
  },
  {
    value: "Europe/Zurich",
    label: "(GMT+02:00) Europe/Zurich",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Europe/Zurich
      </span>
    ),
  },
  // Additional Pacific timezones
  {
    value: "Pacific/Apia",
    label: "(GMT+13:00) Pacific/Apia",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+13:00) Pacific/Apia
      </span>
    ),
  },
  {
    value: "Pacific/Bougainville",
    label: "(GMT+11:00) Pacific/Bougainville",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Pacific/Bougainville
      </span>
    ),
  },
  {
    value: "Pacific/Chatham",
    label: "(GMT+12:45) Pacific/Chatham",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:45) Pacific/Chatham
      </span>
    ),
  },
  {
    value: "Pacific/Chuuk",
    label: "(GMT+10:00) Pacific/Chuuk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Pacific/Chuuk
      </span>
    ),
  },
  {
    value: "Pacific/Easter",
    label: "(GMT-06:00) Pacific/Easter",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) Pacific/Easter
      </span>
    ),
  },
  {
    value: "Pacific/Efate",
    label: "(GMT+11:00) Pacific/Efate",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Pacific/Efate
      </span>
    ),
  },
  {
    value: "Pacific/Enderbury",
    label: "(GMT+13:00) Pacific/Enderbury",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+13:00) Pacific/Enderbury
      </span>
    ),
  },
  {
    value: "Pacific/Fakaofo",
    label: "(GMT+13:00) Pacific/Fakaofo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+13:00) Pacific/Fakaofo
      </span>
    ),
  },
  {
    value: "Pacific/Fiji",
    label: "(GMT+12:00) Pacific/Fiji",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Pacific/Fiji
      </span>
    ),
  },
  {
    value: "Pacific/Funafuti",
    label: "(GMT+12:00) Pacific/Funafuti",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Pacific/Funafuti
      </span>
    ),
  },
  {
    value: "Pacific/Galapagos",
    label: "(GMT-06:00) Pacific/Galapagos",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) Pacific/Galapagos
      </span>
    ),
  },
  {
    value: "Pacific/Gambier",
    label: "(GMT-09:00) Pacific/Gambier",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-09:00) Pacific/Gambier
      </span>
    ),
  },
  {
    value: "Pacific/Guadalcanal",
    label: "(GMT+11:00) Pacific/Guadalcanal",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Pacific/Guadalcanal
      </span>
    ),
  },
  {
    value: "Pacific/Guam",
    label: "(GMT+10:00) Pacific/Guam",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Pacific/Guam
      </span>
    ),
  },
  {
    value: "Pacific/Johnston",
    label: "(GMT-10:00) Pacific/Johnston",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-10:00) Pacific/Johnston
      </span>
    ),
  },
  {
    value: "Pacific/Kanton",
    label: "(GMT+13:00) Pacific/Kanton",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+13:00) Pacific/Kanton
      </span>
    ),
  },
  {
    value: "Pacific/Kiritimati",
    label: "(GMT+14:00) Pacific/Kiritimati",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+14:00) Pacific/Kiritimati
      </span>
    ),
  },
  {
    value: "Pacific/Kosrae",
    label: "(GMT+11:00) Pacific/Kosrae",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Pacific/Kosrae
      </span>
    ),
  },
  {
    value: "Pacific/Kwajalein",
    label: "(GMT+12:00) Pacific/Kwajalein",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Pacific/Kwajalein
      </span>
    ),
  },
  {
    value: "Pacific/Majuro",
    label: "(GMT+12:00) Pacific/Majuro",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Pacific/Majuro
      </span>
    ),
  },
  {
    value: "Pacific/Nauru",
    label: "(GMT+12:00) Pacific/Nauru",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Pacific/Nauru
      </span>
    ),
  },
  {
    value: "Pacific/Norfolk",
    label: "(GMT+11:00) Pacific/Norfolk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Pacific/Norfolk
      </span>
    ),
  },
  {
    value: "Pacific/Noumea",
    label: "(GMT+11:00) Pacific/Noumea",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Pacific/Noumea
      </span>
    ),
  },
  {
    value: "Pacific/Palau",
    label: "(GMT+09:00) Pacific/Palau",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) Pacific/Palau
      </span>
    ),
  },
  {
    value: "Pacific/Pohnpei",
    label: "(GMT+11:00) Pacific/Pohnpei",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Pacific/Pohnpei
      </span>
    ),
  },
  {
    value: "Pacific/Ponape",
    label: "(GMT+11:00) Pacific/Ponape",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Pacific/Ponape
      </span>
    ),
  },
  {
    value: "Pacific/Port_Moresby",
    label: "(GMT+10:00) Pacific/Port_Moresby",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Pacific/Port_Moresby
      </span>
    ),
  },
  {
    value: "Pacific/Saipan",
    label: "(GMT+10:00) Pacific/Saipan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Pacific/Saipan
      </span>
    ),
  },
  {
    value: "Pacific/Samoa",
    label: "(GMT-11:00) Pacific/Samoa",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-11:00) Pacific/Samoa
      </span>
    ),
  },
  {
    value: "Pacific/Tarawa",
    label: "(GMT+12:00) Pacific/Tarawa",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Pacific/Tarawa
      </span>
    ),
  },
  {
    value: "Pacific/Tongatapu",
    label: "(GMT+13:00) Pacific/Tongatapu",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+13:00) Pacific/Tongatapu
      </span>
    ),
  },
  {
    value: "Pacific/Truk",
    label: "(GMT+10:00) Pacific/Truk",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Pacific/Truk
      </span>
    ),
  },
  {
    value: "Pacific/Wake",
    label: "(GMT+12:00) Pacific/Wake",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Pacific/Wake
      </span>
    ),
  },
  {
    value: "Pacific/Wallis",
    label: "(GMT+12:00) Pacific/Wallis",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Pacific/Wallis
      </span>
    ),
  },
  {
    value: "Pacific/Yap",
    label: "(GMT+10:00) Pacific/Yap",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Pacific/Yap
      </span>
    ),
  },
  // Indian Ocean timezones
  {
    value: "Indian/Antananarivo",
    label: "(GMT+03:00) Indian/Antananarivo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Indian/Antananarivo
      </span>
    ),
  },
  {
    value: "Indian/Chagos",
    label: "(GMT+06:00) Indian/Chagos",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Indian/Chagos
      </span>
    ),
  },
  {
    value: "Indian/Christmas",
    label: "(GMT+07:00) Indian/Christmas",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Indian/Christmas
      </span>
    ),
  },
  {
    value: "Indian/Cocos",
    label: "(GMT+06:30) Indian/Cocos",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:30) Indian/Cocos
      </span>
    ),
  },
  {
    value: "Indian/Comoro",
    label: "(GMT+03:00) Indian/Comoro",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Indian/Comoro
      </span>
    ),
  },
  {
    value: "Indian/Kerguelen",
    label: "(GMT+05:00) Indian/Kerguelen",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Indian/Kerguelen
      </span>
    ),
  },
  {
    value: "Indian/Mahe",
    label: "(GMT+04:00) Indian/Mahe",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Indian/Mahe
      </span>
    ),
  },
  {
    value: "Indian/Maldives",
    label: "(GMT+05:00) Indian/Maldives",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Indian/Maldives
      </span>
    ),
  },
  {
    value: "Indian/Mauritius",
    label: "(GMT+04:00) Indian/Mauritius",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Indian/Mauritius
      </span>
    ),
  },
  {
    value: "Indian/Mayotte",
    label: "(GMT+03:00) Indian/Mayotte",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Indian/Mayotte
      </span>
    ),
  },
  {
    value: "Indian/Reunion",
    label: "(GMT+04:00) Indian/Reunion",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Indian/Reunion
      </span>
    ),
  },
  // Common timezone abbreviations and aliases
  {
    value: "Etc/GMT",
    label: "(GMT+00:00) Etc/GMT",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Etc/GMT
      </span>
    ),
  },
  {
    value: "Etc/GMT+0",
    label: "(GMT+00:00) Etc/GMT+0",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Etc/GMT+0
      </span>
    ),
  },
  {
    value: "Etc/GMT+1",
    label: "(GMT-01:00) Etc/GMT+1",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-01:00) Etc/GMT+1
      </span>
    ),
  },
  {
    value: "Etc/GMT+10",
    label: "(GMT-10:00) Etc/GMT+10",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-10:00) Etc/GMT+10
      </span>
    ),
  },
  {
    value: "Etc/GMT+11",
    label: "(GMT-11:00) Etc/GMT+11",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-11:00) Etc/GMT+11
      </span>
    ),
  },
  {
    value: "Etc/GMT+12",
    label: "(GMT-12:00) Etc/GMT+12",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-12:00) Etc/GMT+12
      </span>
    ),
  },
  {
    value: "Etc/GMT+2",
    label: "(GMT-02:00) Etc/GMT+2",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-02:00) Etc/GMT+2
      </span>
    ),
  },
  {
    value: "Etc/GMT+3",
    label: "(GMT-03:00) Etc/GMT+3",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-03:00) Etc/GMT+3
      </span>
    ),
  },
  {
    value: "Etc/GMT+4",
    label: "(GMT-04:00) Etc/GMT+4",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) Etc/GMT+4
      </span>
    ),
  },
  {
    value: "Etc/GMT+5",
    label: "(GMT-05:00) Etc/GMT+5",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) Etc/GMT+5
      </span>
    ),
  },
  {
    value: "Etc/GMT+6",
    label: "(GMT-06:00) Etc/GMT+6",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) Etc/GMT+6
      </span>
    ),
  },
  {
    value: "Etc/GMT+7",
    label: "(GMT-07:00) Etc/GMT+7",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) Etc/GMT+7
      </span>
    ),
  },
  {
    value: "Etc/GMT+8",
    label: "(GMT-08:00) Etc/GMT+8",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-08:00) Etc/GMT+8
      </span>
    ),
  },
  {
    value: "Etc/GMT+9",
    label: "(GMT-09:00) Etc/GMT+9",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-09:00) Etc/GMT+9
      </span>
    ),
  },
  {
    value: "Etc/GMT-0",
    label: "(GMT+00:00) Etc/GMT-0",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Etc/GMT-0
      </span>
    ),
  },
  {
    value: "Etc/GMT-1",
    label: "(GMT+01:00) Etc/GMT-1",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Etc/GMT-1
      </span>
    ),
  },
  {
    value: "Etc/GMT-10",
    label: "(GMT+10:00) Etc/GMT-10",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Etc/GMT-10
      </span>
    ),
  },
  {
    value: "Etc/GMT-11",
    label: "(GMT+11:00) Etc/GMT-11",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+11:00) Etc/GMT-11
      </span>
    ),
  },
  {
    value: "Etc/GMT-12",
    label: "(GMT+12:00) Etc/GMT-12",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Etc/GMT-12
      </span>
    ),
  },
  {
    value: "Etc/GMT-13",
    label: "(GMT+13:00) Etc/GMT-13",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+13:00) Etc/GMT-13
      </span>
    ),
  },
  {
    value: "Etc/GMT-14",
    label: "(GMT+14:00) Etc/GMT-14",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+14:00) Etc/GMT-14
      </span>
    ),
  },
  {
    value: "Etc/GMT-2",
    label: "(GMT+02:00) Etc/GMT-2",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Etc/GMT-2
      </span>
    ),
  },
  {
    value: "Etc/GMT-3",
    label: "(GMT+03:00) Etc/GMT-3",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Etc/GMT-3
      </span>
    ),
  },
  {
    value: "Etc/GMT-4",
    label: "(GMT+04:00) Etc/GMT-4",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+04:00) Etc/GMT-4
      </span>
    ),
  },
  {
    value: "Etc/GMT-5",
    label: "(GMT+05:00) Etc/GMT-5",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:00) Etc/GMT-5
      </span>
    ),
  },
  {
    value: "Etc/GMT-6",
    label: "(GMT+06:00) Etc/GMT-6",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+06:00) Etc/GMT-6
      </span>
    ),
  },
  {
    value: "Etc/GMT-7",
    label: "(GMT+07:00) Etc/GMT-7",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+07:00) Etc/GMT-7
      </span>
    ),
  },
  {
    value: "Etc/GMT-8",
    label: "(GMT+08:00) Etc/GMT-8",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Etc/GMT-8
      </span>
    ),
  },
  {
    value: "Etc/GMT-9",
    label: "(GMT+09:00) Etc/GMT-9",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) Etc/GMT-9
      </span>
    ),
  },
  {
    value: "Etc/GMT0",
    label: "(GMT+00:00) Etc/GMT0",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Etc/GMT0
      </span>
    ),
  },
  {
    value: "Etc/Greenwich",
    label: "(GMT+00:00) Etc/Greenwich",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Etc/Greenwich
      </span>
    ),
  },
  {
    value: "Etc/UCT",
    label: "(GMT+00:00) Etc/UCT",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Etc/UCT
      </span>
    ),
  },
  {
    value: "Etc/UTC",
    label: "(GMT+00:00) Etc/UTC",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Etc/UTC
      </span>
    ),
  },
  {
    value: "Etc/Universal",
    label: "(GMT+00:00) Etc/Universal",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Etc/Universal
      </span>
    ),
  },
  {
    value: "Etc/Zulu",
    label: "(GMT+00:00) Etc/Zulu",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Etc/Zulu
      </span>
    ),
  },
  {
    value: "GB",
    label: "(GMT+01:00) GB",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) GB
      </span>
    ),
  },
  {
    value: "GB-Eire",
    label: "(GMT+01:00) GB-Eire",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) GB-Eire
      </span>
    ),
  },
  {
    value: "GMT",
    label: "(GMT+00:00) GMT",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) GMT
      </span>
    ),
  },
  {
    value: "GMT+0",
    label: "(GMT+00:00) GMT+0",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) GMT+0
      </span>
    ),
  },
  {
    value: "GMT-0",
    label: "(GMT+00:00) GMT-0",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) GMT-0
      </span>
    ),
  },
  {
    value: "GMT0",
    label: "(GMT+00:00) GMT0",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) GMT0
      </span>
    ),
  },
  {
    value: "Greenwich",
    label: "(GMT+00:00) Greenwich",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Greenwich
      </span>
    ),
  },
  {
    value: "HST",
    label: "(GMT-10:00) HST",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-10:00) HST
      </span>
    ),
  },
  {
    value: "Hongkong",
    label: "(GMT+08:00) Hongkong",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Hongkong
      </span>
    ),
  },
  {
    value: "Iceland",
    label: "(GMT+00:00) Iceland",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Iceland
      </span>
    ),
  },
  {
    value: "Iran",
    label: "(GMT+03:30) Iran",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:30) Iran
      </span>
    ),
  },
  {
    value: "Israel",
    label: "(GMT+03:00) Israel",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Israel
      </span>
    ),
  },
  {
    value: "Jamaica",
    label: "(GMT-05:00) Jamaica",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) Jamaica
      </span>
    ),
  },
  {
    value: "Japan",
    label: "(GMT+09:00) Japan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) Japan
      </span>
    ),
  },
  {
    value: "Kwajalein",
    label: "(GMT+12:00) Kwajalein",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) Kwajalein
      </span>
    ),
  },
  {
    value: "Libya",
    label: "(GMT+02:00) Libya",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Libya
      </span>
    ),
  },
  {
    value: "MET",
    label: "(GMT+02:00) MET",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) MET
      </span>
    ),
  },
  {
    value: "MST",
    label: "(GMT-07:00) MST",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) MST
      </span>
    ),
  },
  {
    value: "MST7MDT",
    label: "(GMT-06:00) MST7MDT",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) MST7MDT
      </span>
    ),
  },
  {
    value: "Mexico/BajaSur",
    label: "(GMT-07:00) Mexico/BajaSur",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) Mexico/BajaSur
      </span>
    ),
  },
  {
    value: "Mexico/General",
    label: "(GMT-06:00) Mexico/General",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) Mexico/General
      </span>
    ),
  },
  {
    value: "NZ",
    label: "(GMT+12:00) NZ",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:00) NZ
      </span>
    ),
  },
  {
    value: "NZ-CHAT",
    label: "(GMT+12:45) NZ-CHAT",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+12:45) NZ-CHAT
      </span>
    ),
  },
  {
    value: "Navajo",
    label: "(GMT-06:00) Navajo",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) Navajo
      </span>
    ),
  },
  {
    value: "PRC",
    label: "(GMT+08:00) PRC",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) PRC
      </span>
    ),
  },
  {
    value: "PST8PDT",
    label: "(GMT-07:00) PST8PDT",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) PST8PDT
      </span>
    ),
  },
  {
    value: "Poland",
    label: "(GMT+02:00) Poland",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+02:00) Poland
      </span>
    ),
  },
  {
    value: "Portugal",
    label: "(GMT+01:00) Portugal",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) Portugal
      </span>
    ),
  },
  {
    value: "ROC",
    label: "(GMT+08:00) ROC",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) ROC
      </span>
    ),
  },
  {
    value: "ROK",
    label: "(GMT+09:00) ROK",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+09:00) ROK
      </span>
    ),
  },
  {
    value: "Singapore",
    label: "(GMT+08:00) Singapore",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Singapore
      </span>
    ),
  },
  {
    value: "Turkey",
    label: "(GMT+03:00) Turkey",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) Turkey
      </span>
    ),
  },
  {
    value: "UCT",
    label: "(GMT+00:00) UCT",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) UCT
      </span>
    ),
  },
  {
    value: "US/Alaska",
    label: "(GMT-08:00) US/Alaska",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-08:00) US/Alaska
      </span>
    ),
  },
  {
    value: "US/Aleutian",
    label: "(GMT-09:00) US/Aleutian",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-09:00) US/Aleutian
      </span>
    ),
  },
  {
    value: "US/Arizona",
    label: "(GMT-07:00) US/Arizona",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) US/Arizona
      </span>
    ),
  },
  {
    value: "US/Central",
    label: "(GMT-05:00) US/Central",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) US/Central
      </span>
    ),
  },
  {
    value: "US/East-Indiana",
    label: "(GMT-04:00) US/East-Indiana",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) US/East-Indiana
      </span>
    ),
  },
  {
    value: "US/Eastern",
    label: "(GMT-04:00) US/Eastern",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) US/Eastern
      </span>
    ),
  },
  {
    value: "US/Hawaii",
    label: "(GMT-10:00) US/Hawaii",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-10:00) US/Hawaii
      </span>
    ),
  },
  {
    value: "US/Indiana-Starke",
    label: "(GMT-05:00) US/Indiana-Starke",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-05:00) US/Indiana-Starke
      </span>
    ),
  },
  {
    value: "US/Michigan",
    label: "(GMT-04:00) US/Michigan",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-04:00) US/Michigan
      </span>
    ),
  },
  {
    value: "US/Mountain",
    label: "(GMT-06:00) US/Mountain",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-06:00) US/Mountain
      </span>
    ),
  },
  {
    value: "US/Pacific",
    label: "(GMT-07:00) US/Pacific",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-07:00) US/Pacific
      </span>
    ),
  },
  {
    value: "US/Samoa",
    label: "(GMT-11:00) US/Samoa",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT-11:00) US/Samoa
      </span>
    ),
  },
  {
    value: "UTC",
    label: "(GMT+00:00) UTC",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) UTC
      </span>
    ),
  },
  {
    value: "Universal",
    label: "(GMT+00:00) Universal",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Universal
      </span>
    ),
  },
  {
    value: "W-SU",
    label: "(GMT+03:00) W-SU",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+03:00) W-SU
      </span>
    ),
  },
  {
    value: "WET",
    label: "(GMT+01:00) WET",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+01:00) WET
      </span>
    ),
  },
  {
    value: "Zulu",
    label: "(GMT+00:00) Zulu",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+00:00) Zulu
      </span>
    ),
  },
];
